<template>
  <div id="app" v-if="main_switch">
    <transition name="fade">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.title" />
      </keep-alive>
    </transition>

    <transition name="fade">
      <router-view
        v-if="$route.meta.keepAlive !=true || $route.meta.keepAlive==undefined"
        v-wechat-title="$route.meta.title"
      />
    </transition>
  </div>
</template>

<script>
import requestIsMember from '@/assets/js/Commonmethods.js'

export default {
  name: "App",
  data() {
    return {
      main_switch: false,
      uuid: "",
      detailRouter: ['detail']
    };
  },
  watch: {
    $route(value) {
      // this.commonM.Buried_point({
      //   // 行为标签id
      //   actionTagIds: "27",
      //   // 来源标题
      //   viewTitle: this.$route.meta.title,
      //   // 来源地址
      //   viewUrl: window.location.href,
      // });
      // console.log( window.location.href)

    },
    '$route': {
      handler(newVal, oldVal) {
        jsAuto(1);
        customizeParam({
          appId: "wx14d37d47cdf1b908",
          imgUrl:
            "https://www.commnowmatrix.com/group1/M00/00/15/ag7K7l6-RnqACKyKAABIdr8Sl5Y083.jpg",
          title: this.$route.meta.title,
          desc: "西门子数字化工业软件",
          link: this.$href + this.$route.fullPath,
        });
        getWeichatCode();
        var result = this.detailRouter.some(item => {
          return item == newVal.name;
        });
        if (!result) {
          this.emit({
            type: 'browse'
          })
        }
      }
    }
  },
  created() {
    let $this = this;
    // 判断是否是会员;
    // this.commonM.requestIsMember();
    // 微信授权;
    // let evox = new Evox({
    //   axios,
    //   appId : "wx14d37d47cdf1b908",
    //   isMandatoryWxAuth:true
    // });
    // let result = evox.wxLogin();
    //   result.then(res => {
    if (localStorage.getItem('res')) {
      let res = localStorage.getItem('res');
      // localStorage.setItem("openid", res.channelUid);
      // localStorage.setItem("userid", res.id);
      this.main_switch = true
      requestIsMember.requestIsMember($this)
      // Vue.prototype.userInfo = res
    }

    // });
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
.fade-enter-active,
.fade-leave-avtive {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
html,
body {
  width: 100%;
  height: 100%;
}
a {
  color: #2c3e50;
}
#app {
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#app /deep/ .van-dialog {
  background-color: none;
}
message_updateInformationTime.van-dial {
  background: rgba(56, 185, 175, 0.95);
}
.message_updateInformationTime .van-dialog__footer {
  background: rgba(56, 185, 175, 0.95);
}
.message_updateInformationTime {
  background: rgba(56, 185, 175, 0.95) !important;
  color: white;
}
.message_updateInformationTime .van-button {
  background: rgba(56, 185, 175, 0.95);
}
.message_updateInformationTime /deep/ p {
  margin-bottom: 0.15rem;
}
.updateInformationTime_box {
  position: relative;
  top: -1rem;
  color: white;
}
.updateInformationTime_box_head {
  color: white;
  position: relative;
  top: -0.5rem;
}
.message_updateInformationTime .van-dialog__message {
  padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue